import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React, { useCallback } from "react";
import { BreakpointsConsumer } from "../Breakpoints/BreakpointsProvider";
export var OnWhen = function(param1) {
    var defaultSize = param1.defaultSize, s = param1.s, m = param1.m, l = param1.l, xl = param1.xl, ssr = param1.ssr, children = param1.children;
    var checkProps = useCallback(function(param) {
        var isS = param.isS, isM = param.isM, isL = param.isL, isXL = param.isXL, isXXL = param.isXXL, isDefaultSize = param.isDefaultSize, isSsr = param.isSsr;
        switch(true){
            case !isS && !isM && !isL && !isXL && !isXXL && !isDefaultSize && !isSsr:
                return true;
            case !defaultSize && !s && !m && !l && !ssr && !xl:
                return true;
            case defaultSize && isDefaultSize:
                return true;
            case s && isS:
                return true;
            case m && isM:
                return true;
            case l && isL:
                return true;
            case xl && (isXL || isXXL):
                return true;
            case ssr && isSsr:
                return true;
            default:
                return false;
        }
    }, [
        defaultSize,
        s,
        m,
        l,
        xl,
        ssr
    ]);
    return _jsx(BreakpointsConsumer, {
        children: function(breakpointsAndDims) {
            if (checkProps(breakpointsAndDims)) {
                return children;
            }
            return null;
        }
    });
};
export default OnWhen;
